/**
 * 3-Column Testimonials Template
 *
 * Three testimonial cards in a row with author attribution.
 */

const testimonial3col = {
  id: 'testimonial-3col',
  name: '3-Column Testimonials',
  category: 'testimonials',
  description: 'Three testimonial cards with quotes and author information',
  thumbnail: null,
  content: {
    section_type: 'layout-1',
    sectionBackgroundColor: '#f5f5f5',
    backgroundImage: '',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    marginTop: '0',
    marginBottom: '0',
    paddingTop: '64',
    paddingBottom: '64',
    paddingLeft: '24',
    paddingRight: '24',
    components: [
      {
        id: 'testimonial-3col-row-1',
        type: 'row',
        props: {
          direction: { base: 'horizontal', tablet: null, desktop: null },
          gap: 'lg',
          alignment: 'stretch',
          justifyContent: 'center',
          flexWrap: 'wrap',
          columnLayout: { base: 'equal', tablet: null, desktop: null },
          columnWidths: [],
          width: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          maxWidth: { base: { value: '1200', unit: 'px' }, tablet: null, desktop: null },
          padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
          margin: { base: { top: 0, bottom: 0, left: 'auto', right: 'auto', unit: 'px' }, tablet: null, desktop: null },
          backgroundColor: 'transparent',
          backgroundImageUrl: '',
          borderWidth: 0,
          borderStyle: 'solid',
          borderColor: 'transparent',
          borderRadius: 0,
          overflow: 'visible',
          visibility: { base: true, tablet: null, desktop: null },
          position: 'relative',
          top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          zIndex: 'auto',
          customCSS: 'gap: 24px;',
        },
        children: [
          // Column 1
          {
            id: 'testimonial-3col-col-1',
            type: 'column',
            props: {
              gap: 'sm',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              span: { base: 12, tablet: 4, desktop: 4 },
              width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
              padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              backgroundColor: 'transparent',
              borderWidth: 0,
              borderStyle: 'solid',
              borderColor: 'transparent',
              borderRadius: 0,
              overflow: 'visible',
              visibility: { base: true, tablet: null, desktop: null },
              position: 'relative',
              top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              zIndex: 'auto',
              customCSS: '',
            },
            children: [
              {
                id: 'testimonial-3col-card-1',
                type: 'container',
                props: {
                  width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
                  height: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  padding: { base: { top: 24, bottom: 24, left: 24, right: 24, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  backgroundColor: '#ffffff',
                  backgroundImageUrl: '',
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 16,
                  overflow: 'visible',
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'relative',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: 'box-shadow: 0 2px 8px rgba(0,0,0,0.08);',
                },
                children: [
                  {
                    id: 'testimonial-3col-quote-1',
                    type: 'text',
                    props: {
                      content: '"The best investment we made this year. Outstanding results from day one."',
                      element: 'p',
                      fontFamily: 'System Default',
                      fontSize: 16,
                      fontWeight: 'normal',
                      lineHeight: 1.5,
                      letterSpacing: 0,
                      color: '#333333',
                      textAlign: 'left',
                      textTransform: 'none',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 16, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      visibility: { base: true, tablet: null, desktop: null },
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                  {
                    id: 'testimonial-3col-author-1',
                    type: 'text',
                    props: {
                      content: 'Michael Chen',
                      element: 'p',
                      fontFamily: 'System Default',
                      fontSize: 14,
                      fontWeight: 'bold',
                      lineHeight: 1.4,
                      letterSpacing: 0,
                      color: '#1a1a1a',
                      textAlign: 'left',
                      textTransform: 'none',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 4, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      visibility: { base: true, tablet: null, desktop: null },
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                  {
                    id: 'testimonial-3col-role-1',
                    type: 'text',
                    props: {
                      content: 'CTO, StartupXYZ',
                      element: 'p',
                      fontFamily: 'System Default',
                      fontSize: 12,
                      fontWeight: 'normal',
                      lineHeight: 1.4,
                      letterSpacing: 0,
                      color: '#999999',
                      textAlign: 'left',
                      textTransform: 'none',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      visibility: { base: true, tablet: null, desktop: null },
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                ],
              },
            ],
          },
          // Column 2
          {
            id: 'testimonial-3col-col-2',
            type: 'column',
            props: {
              gap: 'sm',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              span: { base: 12, tablet: 4, desktop: 4 },
              width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
              padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              backgroundColor: 'transparent',
              borderWidth: 0,
              borderStyle: 'solid',
              borderColor: 'transparent',
              borderRadius: 0,
              overflow: 'visible',
              visibility: { base: true, tablet: null, desktop: null },
              position: 'relative',
              top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              zIndex: 'auto',
              customCSS: '',
            },
            children: [
              {
                id: 'testimonial-3col-card-2',
                type: 'container',
                props: {
                  width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
                  height: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  padding: { base: { top: 24, bottom: 24, left: 24, right: 24, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  backgroundColor: '#ffffff',
                  backgroundImageUrl: '',
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 16,
                  overflow: 'visible',
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'relative',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: 'box-shadow: 0 2px 8px rgba(0,0,0,0.08);',
                },
                children: [
                  {
                    id: 'testimonial-3col-quote-2',
                    type: 'text',
                    props: {
                      content: '"Incredible support team and a product that just works. Saved us countless hours."',
                      element: 'p',
                      fontFamily: 'System Default',
                      fontSize: 16,
                      fontWeight: 'normal',
                      lineHeight: 1.5,
                      letterSpacing: 0,
                      color: '#333333',
                      textAlign: 'left',
                      textTransform: 'none',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 16, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      visibility: { base: true, tablet: null, desktop: null },
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                  {
                    id: 'testimonial-3col-author-2',
                    type: 'text',
                    props: {
                      content: 'Sarah Johnson',
                      element: 'p',
                      fontFamily: 'System Default',
                      fontSize: 14,
                      fontWeight: 'bold',
                      lineHeight: 1.4,
                      letterSpacing: 0,
                      color: '#1a1a1a',
                      textAlign: 'left',
                      textTransform: 'none',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 4, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      visibility: { base: true, tablet: null, desktop: null },
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                  {
                    id: 'testimonial-3col-role-2',
                    type: 'text',
                    props: {
                      content: 'Marketing Director, Acme Inc',
                      element: 'p',
                      fontFamily: 'System Default',
                      fontSize: 12,
                      fontWeight: 'normal',
                      lineHeight: 1.4,
                      letterSpacing: 0,
                      color: '#999999',
                      textAlign: 'left',
                      textTransform: 'none',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      visibility: { base: true, tablet: null, desktop: null },
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                ],
              },
            ],
          },
          // Column 3
          {
            id: 'testimonial-3col-col-3',
            type: 'column',
            props: {
              gap: 'sm',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              span: { base: 12, tablet: 4, desktop: 4 },
              width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
              padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              backgroundColor: 'transparent',
              borderWidth: 0,
              borderStyle: 'solid',
              borderColor: 'transparent',
              borderRadius: 0,
              overflow: 'visible',
              visibility: { base: true, tablet: null, desktop: null },
              position: 'relative',
              top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              zIndex: 'auto',
              customCSS: '',
            },
            children: [
              {
                id: 'testimonial-3col-card-3',
                type: 'container',
                props: {
                  width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
                  height: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  padding: { base: { top: 24, bottom: 24, left: 24, right: 24, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  backgroundColor: '#ffffff',
                  backgroundImageUrl: '',
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 16,
                  overflow: 'visible',
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'relative',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: 'box-shadow: 0 2px 8px rgba(0,0,0,0.08);',
                },
                children: [
                  {
                    id: 'testimonial-3col-quote-3',
                    type: 'text',
                    props: {
                      content: '"A game-changer for our business. The ROI has been phenomenal."',
                      element: 'p',
                      fontFamily: 'System Default',
                      fontSize: 16,
                      fontWeight: 'normal',
                      lineHeight: 1.5,
                      letterSpacing: 0,
                      color: '#333333',
                      textAlign: 'left',
                      textTransform: 'none',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 16, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      visibility: { base: true, tablet: null, desktop: null },
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                  {
                    id: 'testimonial-3col-author-3',
                    type: 'text',
                    props: {
                      content: 'David Park',
                      element: 'p',
                      fontFamily: 'System Default',
                      fontSize: 14,
                      fontWeight: 'bold',
                      lineHeight: 1.4,
                      letterSpacing: 0,
                      color: '#1a1a1a',
                      textAlign: 'left',
                      textTransform: 'none',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 4, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      visibility: { base: true, tablet: null, desktop: null },
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                  {
                    id: 'testimonial-3col-role-3',
                    type: 'text',
                    props: {
                      content: 'Founder, TechFlow',
                      element: 'p',
                      fontFamily: 'System Default',
                      fontSize: 12,
                      fontWeight: 'normal',
                      lineHeight: 1.4,
                      letterSpacing: 0,
                      color: '#999999',
                      textAlign: 'left',
                      textTransform: 'none',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      visibility: { base: true, tablet: null, desktop: null },
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};

export default testimonial3col;
